import React, { useCallback, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FiSettings } from "react-icons/fi";
import { FaRegEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import { MdHistory } from "react-icons/md";
import { AiOutlineFileSearch } from "react-icons/ai";
import { VscReport } from "react-icons/vsc";
import { GoReport, GoStop } from "react-icons/go";
// import { TbReportAnalytics, TbReport, TbReportSearch } from "react-icons/tb";
import { HiOutlineDocumentReport } from "react-icons/hi";

import {
  checkStringsAreEqual,
  checkUserIsOfSameSite,
  getLoggedInUserId,
  isUserInvestigator,
  isUserMM,
  isUserRO,
  isUserSO,
  LOGGED_USER_ID,
} from "../IncidentManagement/Helper";
import { getAllIncidents } from "app/_services/ehs/ehsIncidentServices";
import { incidentStatuses } from "./CONSTANTS";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { ACTIVE_MODULE } from "app/_constants/constant";

const IncidentManagement = ({
  match: {
    params: { siteId },
  },
}) => {
  const [incidents, setIncidents] = useState([]);

  // useEffect(() => {
  //   setIncidentsTable(
  //     incidents.filter((row) => {
  //       return showEditIcon(row) ? true : false;
  //     })
  //   );
  // }, []);
  const isUserInvestigatorOfIncident = (row) => {
    let isInvetigator = false;
    let investigatorId = row?.investigationDetails?.investigator.id;
    let currentId = getLoggedInUserId();
    if (investigatorId == currentId) {
      isInvetigator = true;
    }
    return isInvetigator;
  };

  const showEditIcon = useCallback((row) => {
    let showEditIcon = false;

    if (
      isUserRO() &&
      checkUserIsOfSameSite(row?.siteId) &&
      checkStringsAreEqual(row.incidentStatus, incidentStatuses.draft) &&
      row?.reportedBy === LOGGED_USER_ID()
    ) {
      showEditIcon = true;
    }
    if (
      isUserSO() &&
      checkUserIsOfSameSite(row?.siteId) &&
      (checkStringsAreEqual(row.incidentStatus, incidentStatuses.open) ||
        checkStringsAreEqual(
          row.incidentStatus,
          incidentStatuses.investigationCompleted
        ) ||
        checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaCompleted)) &&
      checkStringsAreEqual(row.reportAtLabel, "so")
    ) {
      showEditIcon = true;
    }
    if (
      isUserMM() &&
      checkUserIsOfSameSite(row?.siteId) &&
      (checkStringsAreEqual(row.incidentStatus, incidentStatuses.capaReviewed) ||
        checkStringsAreEqual(
          row.incidentStatus,
          incidentStatuses.investigationReviewed
        ) ||
        checkStringsAreEqual(row.incidentStatus, incidentStatuses.mmReview)) &&
      checkStringsAreEqual(row.reportAtLabel, "mm")
    ) {
      showEditIcon = true;
    }
    if (
      isUserInvestigatorOfIncident(row) &&
      checkUserIsOfSameSite(row?.siteId) &&
      checkStringsAreEqual(row.incidentStatus, incidentStatuses.investigationProgress)
    ) {
      showEditIcon = true;
    }

    return showEditIcon;
  }, []);

  useEffect(() => {
    getAllIncidents(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
      if (!response?.data) return;
      setIncidents(
        response?.data?.incidentDetails
          ?.map((inc, idx) => ({
            ...inc,
            sid: idx + 1,
          }))
          .filter((row) => {
            return showEditIcon(row) ? true : false;
          })
      );
    });
  }, [siteId]);
  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          { name: "Incident Management", path: "#" },
        ]}
        module={ACTIVE_MODULE.incident}
      />
      <div className="manageBtnScreen">
        <Row>
          {isUserRO() && (
            <Col lg={4} style={{ marginBottom: "40px" }}>
              <Link
                to={
                  (siteId ? `/sites/${siteId}` : "") +
                  "/health-safety-and-environment/incident-management/report/add"
                }
                className="btn manage-btn"
              >
                <VscReport />
                Report Incident
              </Link>
            </Col>
          )}
          {isUserRO() && (
            <Col lg={4}>
              <Link
                to={
                  (siteId ? `/sites/${siteId}` : "") +
                  "/health-safety-and-environment/incident-management/my-incidents"
                }
                className="btn manage-btn"
              >
                <GoReport />
                My Incidents
              </Link>
            </Col>
          )}

          <Col lg={4}>
            <Link
              to={
                (siteId ? `/sites/${siteId}` : "") +
                "/health-safety-and-environment/incident-management/view-incidents"
              }
              className="btn manage-btn"
            >
              <HiOutlineDocumentReport />
              View Incidents
            </Link>
          </Col>

          {(isUserRO() || isUserSO() || isUserMM() || isUserInvestigator()) && (
            <>
              <Col lg={4}>
                <Link
                  to={
                    (siteId ? `/sites/${siteId}` : "") +
                    "/health-safety-and-environment/incident-management/my-approval-incidents"
                  }
                  className="d-block btn manage-btn"
                >
                  <GoStop />
                  <span>My Approval Actions</span>

                  <span className="tabText">
                    {incidents?.length > 100 ? "" : incidents?.length > 10 ? "0" : "00"}
                    {incidents?.length} &nbsp;Actions Due
                  </span>
                </Link>
              </Col>

              <Col lg={4}>
                <Link
                  to={
                    (siteId ? `/sites/${siteId}` : "") +
                    "/health-safety-and-environment/incident-management/my-approval-history-incidents"
                  }
                  className="btn manage-btn"
                >
                  <AiOutlineFileSearch />
                  My Approval History
                </Link>
              </Col>
            </>
          )}
        </Row>
      </div>
    </div>
  );
};

export default IncidentManagement;
